<template>
  <card style="height: 100%;">
    <div
      v-if="metes.length === 1"
      class="device-picker"
      style="right: auto;left: 20px;top: 12px;"
    >
      {{ metes[0].name }}
    </div>

    <el-select
      v-else
      class="device-picker left"
      popper-class="device-picker__popper"
      size="mini"
      style="right: auto;left: 20px;top: 12px;"
      :value="deviceId"
      @input="deviceChange"
    >
      <el-option
        v-for="item in metes"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>

    <echart
      v-if="!loading"
      chartId="meteorology"
      :options="options"
      :height="height - 52"
      style="margin-top: 52px;"
    ></echart>
  </card>
</template>

<script>
import mixin from '../mixin'
import Card from '../card'
import Echart from '@/components/Chart'
import { list, cols } from '@/service/meteorology'
import { subtract, add } from '@/utlis/date'

const ARROW_SIZE = 18
function renderArrow(param, api) {
  const point = api.coord([api.value(0), api.value(6)])

  return {
    type: 'path',
    shape: {
      pathData: 'M31 16l-15-15v9h-26v12h26v9z',
      x: -ARROW_SIZE / 2,
      y: -ARROW_SIZE / 2,
      width: ARROW_SIZE,
      height: ARROW_SIZE
    },
    rotation: (api.value(2) * Math.PI) / 180,
    position: point,
    style: api.style({ stroke: '#fff', lineWidth: 1 })
  }
}

export default {
  mixins: [mixin],
  components: { Card, Echart },
  data() {
    return {
      loadingCols: false, // 初始化列数据
      loading: false,
      deviceId: null,
      data: {
        dataset: { source: [] },
        series: []
      }
    }
  },
  computed: {
    dev() {
      return this.metes.find(m => m.id === this.deviceId)
    },
    isJs() {
      return this.dev && this.dev.key.length === 15
    },
    options() {
      return {
        legend: {
          type: 'scroll',
          left: 52,
          right: '6%',
          bottom: 12,
          pageButtonGap: 20,
          textStyle: { color: '#9aa8d4' },
          pageTextStyle: { color: '#dcdfe6', fontSize: 14 }
        },
        tooltip: {
          transitionDuration: 0
        },
        grid: [
          {
            top: 12,
            left: 52,
            right: 52,
            bottom: '75%'
          },
          {
            top: '35%',
            left: 52,
            right: 52,
            bottom: '40%'
          },
          {
            top: '70%',
            left: 52,
            right: 52,
            bottom: '10%'
          }
        ],
        xAxis: [
          {
            type: 'category',
            gridIndex: 0,
            splitLine: false
          },
          {
            type: 'category',
            // boundaryGap: false,
            gridIndex: 1,
            splitLine: false
          },
          {
            type: 'category',
            // boundaryGap: false,
            gridIndex: 2,
            splitLine: false
          }
        ],
        // yAxis: [
        //   { gridIndex: 0, name: '空气温度(℃)', splitLine: false },
        //   { gridIndex: 0, name: '空气湿度(%RH)', splitLine: false },
        //   { gridIndex: 1, name: '光照强度(Klux)', splitLine: false },
        //   { gridIndex: 1, name: '大气压(Kpa)', splitLine: false },
        //   // { gridIndex: 2, show: false },
        //   { gridIndex: 2, name: '降雨量(mm/h)', splitLine: false },
        //   { gridIndex: 2, name: '风速(m/s)', splitLine: false }
        // ],
        yAxis: this.yaxis(),
        ...this.data
      }
    }
  },
  async mounted() {
    if (this.metes && this.metes[0]) {
      this.deviceId = this.metes[0].id
      await this.getCols()
      this.loading = true
      this.data = await this.getData()
      this.loading = false
    }
  },
  methods: {
    async getCols() {
      this.loadingCols = true
      const { data } = await cols(this.deviceId)
      this.cols = data
      this.loadingCols = false
    },
    async getData() {
      const { data } = await list({
        companyId: this.companyId,
        deviceId: this.deviceId,
        begin: subtract(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
        end: add(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
        type: 'day'
      })

      // const keys = this.cols.filter(c =>
      //   ['airT', 'airH', 'rainfallDat'].includes(c.key)
      // )
      const keys = data.length
        ? this.isJs
          ? this.getKeys()
          : this.getNewKeys()
        : []

      return {
        dataset: {
          dimensions: ['date'].concat(keys.map(c => c.key)),
          source: data
        },
        series: keys.map(k => {
          return {
            // type: k.key === 'Rainfall' ? 'bar' : 'line',
            type: k.type,
            // barWidth: '40%',
            name: k.name,
            xAxisIndex: k.xIndex,
            yAxisIndex: k.yIndex,
            renderItem: k.renderItem,
            symbol: 'none',
            z: k.z || 2
          }
        })
      }
    },
    getKeys() {
      const keys = [
        { key: 'airT', type: 'line', name: '空气温度', xIndex: 0, yIndex: 0 },
        { key: 'airH', type: 'line', name: '空气湿度', xIndex: 0, yIndex: 1 },
        { key: 'sunL', type: 'line', name: '光照强度', xIndex: 1, yIndex: 2 },
        { key: 'pressure', type: 'line', name: '气压', xIndex: 1, yIndex: 3 },
        {
          key: 'rainfallDat',
          type: 'bar',
          name: '降雨量',
          xIndex: 2,
          yIndex: 4
        },
        { key: 'windS', type: 'line', name: '风速', xIndex: 2, yIndex: 5 },
        {
          key: 'windD',
          type: 'custom',
          name: '风向',
          xIndex: 2,
          yIndex: 5,
          renderItem: renderArrow,
          z: 10
        }
      ]

      return keys.map(k => {
        const col = this.cols.find(c => c.name === k.name)
        return { ...k, key: col.key }
      })
    },
    yaxis() {
      return this.isJs
        ? [
            { gridIndex: 0, name: '空气温度(℃)', splitLine: false },
            { gridIndex: 0, name: '空气湿度(%RH)', splitLine: false },
            { gridIndex: 1, name: '光照强度(Klux)', splitLine: false },
            { gridIndex: 1, name: '大气压(Kpa)', splitLine: false },
            // { gridIndex: 2, show: false },
            { gridIndex: 2, name: '降雨量(mm/h)', splitLine: false },
            { gridIndex: 2, name: '风速(m/s)', splitLine: false }
          ]
        : this.cols && this.cols.find(c => c.name.includes('土壤'))
        ? [
            { gridIndex: 0, name: '土壤温度', splitLine: false },
            { gridIndex: 0, name: '土壤湿度', splitLine: false },
            { gridIndex: 1, name: '电导率', splitLine: false },
            { gridIndex: 1, name: 'pH值', splitLine: false },
            // { gridIndex: 2, show: false },
            { gridIndex: 2, name: '离子', splitLine: false }
          ]
        : [
            { gridIndex: 0, name: '空气温度', splitLine: false },
            { gridIndex: 0, name: '空气湿度', splitLine: false },
            { gridIndex: 1, name: '照度', splitLine: false },
            { gridIndex: 1, name: '数字气压', splitLine: false },
            // { gridIndex: 2, show: false },
            { gridIndex: 2, name: '降雨量', splitLine: false },
            { gridIndex: 2, name: '风速', splitLine: false }
          ]
    },
    getNewKeys() {
      const yaxis = this.yaxis()
      return this.cols
        .filter(c => yaxis.find(y => c.name.includes(y.name)))
        .map(c => {
          const y = yaxis.findIndex(y => c.name.includes(y.name))
          return {
            key: c.key,
            type: 'line',
            name: c.name,
            xIndex: y > -1 ? yaxis[y].gridIndex : 0,
            yIndex: y > -1 ? y : 0,
            z: 10
          }
        })
      // if (this.cols && this.cols.find(c => c.name.includes('土壤'))) {
      //   return this.cols.map(c => {
      //     const yaxis = this.yaxis()
      //     const y = yaxis.findIndex(y => c.name.includes(y.name))
      //     return {
      //       key: c.key,
      //       type: 'line',
      //       name: c.name,
      //       xIndex: y > -1 ? yaxis[y].gridIndex : 0,
      //       yIndex: y > -1 ? y : 0,
      //       z: 10
      //     }
      //   })
      // } else {
      //   return []
      // }
    },
    async deviceChange(id) {
      this.deviceId = id
      await this.getCols()
      this.loading = true
      this.data = await this.getData()
      this.loading = false
    }
  }
}
</script>

<style lang="css" scoped></style>
